import { Col, Row, ToggleButton } from "react-bootstrap"
import { useVideoContext } from "../../../context/VideoContext"
import PreviewVideo from "../../PreviewVideo"
import { ButtonWrapper } from "../logo/Position"
import { SettingsContentContainer } from "../Settings"
import { ChooseBackground } from "./ChooseBackground"
import branding from "../../../../branding/branding"

export function BackgroundSettings() {
    const videoContext = useVideoContext()

    return (
        <SettingsContentContainer>
            <Row>
                <Col md={7}>
                    <PreviewVideo />
                    <ButtonWrapper toggle>
                        <ToggleButton
                            style={{ padding: "10px" }}
                            variant="secondary"
                            value="none"
                            onClick={() => videoContext.setBackground("none", null)}
                            checked={videoContext.getBackground() === "none"}
                            type="radio"
                            name="backgroundType"
                        >
                            {branding.audioVideoSettings.radioNoBackground}
                        </ToggleButton>
                        <ToggleButton
                            style={{ padding: "10px" }}
                            variant="secondary"
                            value="blur"
                            onClick={() => videoContext.setBackground("blur", null)}
                            checked={videoContext.getBackground() === "blur"}
                            type="radio"
                            name="backgroundType"
                        >
                            {branding.audioVideoSettings.radioBlurBackground}
                        </ToggleButton>
                    </ButtonWrapper>
                </Col>
                <Col md={5}>
                    <ChooseBackground />
                </Col>
            </Row>
        </SettingsContentContainer>
    )
}
